let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hOVrV")).then(() => parcelRequire('1Ks4Q'));